import {apiRequest} from 'src/gs-api' // Update the path as needed

// Custom hook for tracking resume builder events
export const useResumeEvent = () => {
  const trackStart = async () => {
    await apiRequest<void>('post', '/resume_builder_events', {
      event_type: 'start',
    })
  }

  const trackComplete = async () => {
    await apiRequest<void>('post', '/resume_builder_events', {
      event_type: 'end',
    })
  }

  return {trackStart, trackComplete}
}
